<div class="fdx-o-grid__row">
    <!-- Adding No trusted Device Management message here-->
    <div
        class="fdx-o-grid__item fdx-o-grid__item--12@large fdx-u-align--center fdx-u-bg-color--grey--light-1 fdx-u-elevation--z2 fdx-u-mb--10 fdx-u-px--15@large fdx-u-px--15@medium-only fdx-u-px--3@small-only">
        <p class="fdx-u-font-size--h4 fdx-u-fontweight--light fdx-u-mt--10 fdx-u-mt--15" id="notrustedDevice-title">
            {{'trustedDevices.noTrustedDevicesTitle' | translate}}</p>
        <p class="fdx-c-paragraph fdx-u-font-size--small fdx-u-mb--15  fdx-u-mr--10-large fdx-u-pl--12@large fdx-u-pr--12@large fdx-u-px--6@medium-only" id="notrustedDevice-message">
            {{'trustedDevices.noTrustedDevicesMessage' | translate}}</p>
    </div>
</div>
